<template>
  <div v-if="ancha" class="rf-ancha">
    <img v-if="p.foto" :src="p.foto" :alt="p.nombre">
    <div class="rf-ancha-capa"></div>
    <div class="rf-ancha-texto">
      <div class="rf-badges">
        <span class="rf-badge">{{ p.pais }}</span>
        <button type="button" class="rf-badge" @click="compartir">{{ textoCompartir }}</button>
      </div>
      <h3>{{ p.nombre }}</h3>
      <p class="rf-desc">{{ p.descripcion }}</p>
      <p class="rf-meta-label">Ubicación</p>
      <p class="rf-meta-value">{{ p.ubicacion }}</p>
      <a :href="enlace" class="rf-btn rf-btn--vidrio">Conócelo →</a>
    </div>
  </div>

  <div v-else class="rf-tarjeta">
    <div class="rf-tarjeta-foto">
      <img v-if="p.foto" :src="p.foto" :alt="p.nombre">
      <div class="rf-badges">
        <span class="rf-badge">{{ p.pais }}</span>
        <button type="button" class="rf-badge" @click="compartir">{{ textoCompartir }}</button>
      </div>
    </div>
    <div class="rf-tarjeta-cuerpo">
      <h3>{{ p.nombre }}</h3>
      <p class="rf-desc">{{ p.descripcion }}</p>
      <div class="rf-divisor"></div>
      <div class="rf-meta">
        <div>
          <p class="rf-meta-label">Ubicación</p>
          <p class="rf-meta-value">{{ p.ubicacion }}</p>
        </div>
        <a :href="enlace" class="rf-btn">Conócelo →</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RfTarjeta',
  props: {
    p: { type: Object, required: true },
    ancha: { type: Boolean, default: false },
  },
  data() {
    return { textoCompartir: 'Comparte ↗' };
  },
  computed: {
    enlace() {
      return `/landing-refugios/${this.p.id}`;
    },
  },
  methods: {
    // En el celular abre el menú de compartir; en el computador copia el enlace.
    async compartir() {
      const url = new URL(this.enlace, window.location.origin).href;
      try {
        if (navigator.share) {
          await navigator.share({ title: this.p.nombre, text: this.p.descripcion, url });
          return;
        }
        await navigator.clipboard.writeText(url);
        this.textoCompartir = 'Enlace copiado ✓';
      } catch (e) {
        if (e && e.name === 'AbortError') return;
        this.textoCompartir = 'No se pudo copiar';
      }
      setTimeout(() => { this.textoCompartir = 'Comparte ↗'; }, 2000);
    },
  },
};
</script>
